import React, {useMemo, useState} from 'react';
import {useIntl} from 'react-intl';
import InfiniteScroll from 'react-infinite-scroll-component';
import {useTable} from 'react-table';
import * as actions from '../../_redux/invoiceOrdersActions';
import * as columnFormatters from '../ColumnFormatters';
import * as commonColumnFormatters from '../../../_common/column-formatters';
import {useInvoiceOrdersUIContext} from '../InvoiceOrdersUIContext';
import useInfiniteScrollControl
  from '../../../_common/components/_custom-hooks/useInfiniteScrollControl';

export function InvoiceOrdersTableConfirmCustomers() {
  const {formatMessage} = useIntl();
  const [tableRows, setTableRows] = useState([]);
  const columns = useMemo(() => {
    return window.innerWidth < 990
      ? [
        {
          accessor: 'card',
          Header: ''
        },
        {
          accessor: 'actions',
          Header: ''
        },
      ]
      : [
        {
          accessor: 'createdAt',
          Header: formatMessage({id: 'invoice-orders-column-createdAt', defaultMessage: 'Created at'})
        },
        {
          accessor: 'agent',
          Header: formatMessage({id: 'invoice-orders-column-agent', defaultMessage: 'Agent'})
        },
        {
          accessor: 'customerName',
          Header: formatMessage({id: 'invoice-orders-column-customerName', defaultMessage: 'Customer name'})
        },
        {
          accessor: 'phone',
          Header: formatMessage({id: 'invoice-orders-column-phone', defaultMessage: 'Phone'})
        },
        {
          accessor: 'totalAmount',
          Header: formatMessage({id: 'invoice-orders-column-totalAmount', defaultMessage: 'Total amount'})
        },
        {
          accessor: 'selectCustomer',
          Header: formatMessage({id: 'invoice-orders-column-selectCustomer', defaultMessage: 'Select customer'})
        },
      ];
  }, []);
  const data = useMemo(() => [
    ...tableRows.map((item) => {
      return window.innerWidth < 990
        ? {
          card: columnFormatters.CardEditSendColumnFormatter(item),
          actions: columnFormatters.ConfirmCustomerColumnFormatter(item),
          selectCustomer: columnFormatters.ConfirmCustomerColumnFormatter(item),
        }
        : {
          createdAt: commonColumnFormatters.DateTimeColumnFormatter(item.createdAt),
          agent: columnFormatters.TwoLinesColumnFormatter(item),
          customerName: commonColumnFormatters.LimitContentWidthBoldColumnFormatter(item.customerName),
          phone: commonColumnFormatters.BoldWrapColumnFormatter(item.phone),
          totalAmount: commonColumnFormatters.LimitDecimalColumnFormatter(item.totalAmount),
          selectCustomer: columnFormatters.ConfirmCustomerColumnFormatter(item),
        };
    })
  ], [tableRows]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({columns, data});

  const infiniteScrollProps = useInfiniteScrollControl({
    currentStateStoreId: 'invoiceOrdersConfirmCustomers',
    UIContext: useInvoiceOrdersUIContext(),
    getNewEntities: actions.getInvoiceOrdersConfirmCustomers,
    getNextEntities: actions.getNextInvoiceOrdersConfirmCustomers,
    onEntitiesChange: entities => {
      setTableRows(entities);
    },
    dataLength: tableRows.length,
    scrollableTarget: 'scrollContainer',
    scrollThreshold: 0.9,
    loader: (
      <div className={'spinner-container'}>
        <span className={'spinner spinner-md spinner-primary'}/>
      </div>
    ),
    style: {
      overflow: 'inherit'
    },
  });

  return (
    <div id="scrollContainer">
      <InfiniteScroll {...infiniteScrollProps}>
        <table
          {...getTableProps()}
          className="table table-head-custom table-vertical-center infinite-scroll-table invoice-orders-table-admin"
        >
          <thead className="sticky-header head custom-thead">
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <th
                  {...column.getHeaderProps()}
                  id="custom-brand-color-tableHead"
                >
                  {column.render('Header')}
                </th>
              ))}
            </tr>
          ))}
          </thead>
          <tbody {...getTableBodyProps()} className="body">
          {rows.map((row) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map(cell => {
                  return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>;
                })}
              </tr>
            );
          })}
          </tbody>
        </table>
      </InfiniteScroll>
    </div>
  );
}